import { useEffect, useState } from "react";
import api from "./api";
import { NAME, ROLE, TAGLINE, STATS, LANES, LANE_META } from "../data/lanes";

export const CONTENT_DEFAULTS = {
  hero_kicker: "Designed for forward motion",
  hero_name: NAME,
  hero_role: ROLE,
  hero_tagline: TAGLINE,
  stats: STATS,
  lanes: LANES.map(({ key, title, desc }) => ({ key, title, desc })),
  lane_intros: {
    ux: "Five case studies. One design journey.",
    ...Object.fromEntries(Object.entries(LANE_META).map(([k, v]) => [k, v.intro])),
  },
  about_heading: "I design products, systems, and experiences that bring clarity to complex problems.",
  about_kicker: "About / The person behind the work",
  lane_centers: {
    ux: "UX & Case Studies",
    ...Object.fromEntries(Object.entries(LANE_META).map(([k, v]) => [k, v.center])),
  },
  about_body: "",
  about_portrait: "https://customer-assets-jai6qajn.emergentagent.net/job_design-lanes/artifacts/elguplrl_8833.jpg",
  about_role: "UX • Product • Operations",
  about_focus: "Human-Centered Systems & Digital Experiences",
  about_cert: "Google UX",
  contact_heading: "Let's build something that lasts.",
  contact_sub: "Open to product design, UX, and operations leadership roles and collaborations.",
};

let cache = null;

export function useContent() {
  const [content, setContent] = useState(cache || CONTENT_DEFAULTS);
  useEffect(() => {
    if (cache) return;
    api.get("/content").then((r) => {
      cache = { ...CONTENT_DEFAULTS, ...r.data };
      setContent(cache);
    }).catch(() => {});
  }, []);
  return content;
}

export function invalidateContent() {
  cache = null;
}
